angular.module('impactx.approval').controller('ApprovalDetailRequestCtrl', ['$scope', 'selectedListItems', 'dataGen',
    '$controller', '$mdDialog', 'ProductSelectionService', '$routeParams', '$redirect', 'ToastService', '$errorHandler', 'SubsequentPurchaseOrderDataService', ApprovalDetailRequestCtrl]);

function ApprovalDetailRequestCtrl($scope, selectedListItems, dataGen, $controller, $mdDialog, ProductSelectionService,
                                   $routeParams, $redirect, ToastService, $errorHandler, SubsequentPurchaseOrderDataService) {

    $controller('ApprovalDetailCtrl', {$scope: $scope, backRoute: $routeParams.messages ? "/approvallistopen" : null});

    var atiId = $routeParams.id;
    
    $scope.getPageData = function() {
        dataGen.getData($scope, {id: atiId}, "/approval/view", function() {
            $scope.handleControlDataForChips();
            initRequireControl();
            setChangeAatFunc();
            $scope.setButtons();
            if ($routeParams.messages) {
                var messages = $routeParams.messages.substring(1, $routeParams.messages.length - 1).split(",");
                if (messages.length > 0 && messages[0].length > 0) {
                    ToastService.openStandardToast($scope.trns["message_" + messages[0].trim()]);
                }
            }
            if ($routeParams.warnings) {
                var warnings = $routeParams.warnings.substring(1, $routeParams.warnings.length - 1).split(",");
                if (warnings.length > 0 && warnings[0].length > 0) {
                    var warningsTranslated = [];
                    for (var i = 0; i < warnings.length; i++) {
                        warningsTranslated.push({warning: $scope.trns["warning_" + warnings[i].trim()]});
                    }
                    $errorHandler.showWarnings(warningsTranslated);
                }
            }
            if ($routeParams.errors) {
                var errors = $routeParams.errors.substring(1, $routeParams.errors.length - 1).split(",");
                if (errors.length > 0 && errors[0].length > 0)
                {
                    var errorsTranslated = [];
                    for (var j = 0; j < errors.length; j++) {
                        errorsTranslated.push({error: $scope.trns["error_" + errors[j].trim()]});
                    }
                    $errorHandler.showErrors(errorsTranslated, null, null, false);
                }
            }
        });
    };

    $scope.getHeaderTable = function() {
        return "prh";
    };

    $scope.getDataForItemAction = function() {
        return {
            PRH_Id: $scope.data.approval.headerId,
            PRI_Ids: $scope.selectedItems,
            type: "pri",
            id: $scope.data.approval.id
        };
    };
    $scope.getDataForCSCAction = function(csc_id, prsId) {
        return {
            PRH_Id: $scope.data.approval.headerId,
            CSC_Id: csc_id,
            PRS_Id: prsId,
            type: "prs",
            id: $scope.data.approval.id
        };
    };
    $scope.getDataForHeaderAction = function() {
        return {
            PRH_Id: $scope.data.approval.headerId,
            type: "prh",
            id: $scope.data.approval.id
        };
    };
    $scope.getDataForItemActionOneItem = function(item) {
        return {
            PRH_Id: $scope.data.approval.headerId,
            PRI_Ids: [{id: item.id}],
            type: "pri",
            id: $scope.data.approval.id
        };
    };
    $scope.callEditEntryPoint = function(ev) {
        var basketItemId = 0;
        if($scope.selectedItems[0]) {
            basketItemId = $scope.selectedItems[0].id;
        }
        var entryPointGet;
        var entryPointSave;
        var controller;
        if(basketItemId == 0 || $scope.selectedItems[0].isFreeform) {
            entryPointGet = "/approval/editfreeform";
            entryPointSave = "/approval/savefreeformitem";
            controller = "EditFreeFormCtrl";
        }
        else {
            entryPointGet = "/approval/edit";
            entryPointSave = "/approval/saveitem";
            controller = "EditRequestItemCtrl";
        }

        return $mdDialog.show({
            controller: controller,
            templateUrl: 'shared/requestitem/templates/requestitemdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                itemId: basketItemId,
                headerId: $scope.data.approval.headerId,
                entryPointGet: entryPointGet,
                entryPointSave: entryPointSave,
                changeAATEntryPoint: '/approval/changeaatdetail',
                lotId: -1,
                productId: -1,
                readOnly: false,
                materialGroupMappingEntryPoint: "/approval/input/eclassmapping",
                hideOrderData: false,
                headerTable: "PRH",
                contractId: 0
            }
        })
            .then(function() {
                $scope.getPageData();
                $scope.selectedItems = [];
            }, function() {
            });
    };
    $scope.getPageData();

    $scope.changeProduct = function() {
        var contextUsrId = $scope.selectedItems[0].replaceContextUser;
        var approvalReplaceItem = "PRI." + $scope.selectedItems[0].id;
        var config;
        if ($scope.selectedItems[0].allowOCIReplacement) {
            config = {
                title: $scope.trns.replaceProduct,
                locals: {
                    ctxUsrId: contextUsrId,
                    headerListActions: [{
                        action: $scope.changeProductOCIFromList,
                        label: $scope.trns.replaceProductOCI
                    }]
                }
            };
        }
        else {
            config = {
                title: $scope.trns.replaceProduct,
                locals: {
                    ctxUsrId: contextUsrId
                }
            }
        }
        $scope.lastSelectedItems = $scope.selectedItems.slice();
        $scope.selectedItems = [];
        return ProductSelectionService.open(config).then(function(selectedProduct) {
            if (selectedProduct)
            {
                return dataGen.postAsForm($scope, {
                    proId: selectedProduct.id,
                    priId: $scope.lastSelectedItems[0].id
                }, "/approval/replaceproduct").then(function(){
                    $redirect.reload();
                });
            }
        });
    };

    $scope.changeProductOCIFromList = function(ev) {
        $scope.changeProductOCI(ev, $scope.lastSelectedItems[0]);
    };

    $scope.changeProductOCIFromDialog = function(ev) {
        return $scope.changeProductOCI(ev, $scope.selectedItems[0]);
    };

    $scope.changeProductOCI = function(ev, item) {
        var contextUserId = item.replaceContextUser;

        return $mdDialog.show({
            controller: 'OCIProductReplaceCatalogSelectionCtrl',
            controllerAs: 'ociProductReplaceCatalogSelectionCtrl',
            templateUrl: 'modules/approval/templates/oci-product-replace-catalog-selection.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                contextUserId: contextUserId,
                approvalItem: "PRI." + item.id,
                currentPath: "approvaldetailrequest/" + $routeParams.id
            }
        });
    };

    $scope.redirectToApprovalModified = function(){
        $redirect.redirectTo(null, '/approvalmodifiedpri/'+$scope.selectedItems[0].id);
    };

    var setChangeAatFunc = function() {
        $scope.changeAat = function (aatId, headerId, supplierId, itemId) {
            // the aat is already changed... so get the one from the old settings
            if(impactX.isDefined($scope,"oldApprovalData.approval.aat.selected")) {
                $scope.data.approval.aat.selected = $scope.oldApprovalData.approval.aat.selected;
            }
            $scope.saveData(null, true).then(function(){
                if (angular.isDefined(aatId) && aatId !== null)
                {
                    var params = {
                        atiId: atiId,
                        aatId: aatId,
                        headerId: headerId,
                        suplHeaderId: supplierId,
                        itemId: itemId
                    };
                    dataGen.postAsForm($scope, params, '/approval/changeaat').then(function () {
                        $scope.handleControlDataForChips();
                    });
                }
            });
        }
    };

    $scope.checkAATSelected = function(){
        return impactX.isDefined($scope, 'data.approval.aat.selected.id')
    };
    $scope.checkRequireAAT = function(){
        var result = impactX.isDefined($scope, 'data.approval.aat.showMust');
        if(result){
            var allSuppliersSet = true;
            for(var i = 0; i < $scope.data.approval.contracts.length; i++) { // check the supplier headers
                var supplier = $scope.data.approval.contracts[i];
                var supplierSelected = impactX.isDefined(supplier, 'aat.selected.id');
                if(!supplierSelected){ // if the supplier header is not selected...
                    var itemsSelected = true;
                    for(var j = 0; j < supplier.items.length; j++) { // check the items
                        var item = supplier.items[j];
                        itemsSelected = itemsSelected && impactX.isDefined(item, 'aat.selected.id');
                    }
                    supplierSelected = itemsSelected;
                }
                allSuppliersSet = allSuppliersSet && supplierSelected;
            }
            result = result && !allSuppliersSet;
        }
        return result;
    };

    $scope.checkAATSelectedSupplier = function(supplier){
        return impactX.isDefined(supplier, 'aat.selected.id')
    };
    $scope.checkRequireAATSupplier = function(supplier){
        var result = !$scope.checkAATSelected() && impactX.isDefined(supplier, 'aat.showMust');
        if(result){
            for(var i = 0; i < supplier.items.length; i++) { // check the items
                var item = supplier.items[i];
                result = result && !impactX.isDefined(item, 'aat.selected.id');
            }
        }
        return result;
    };

    $scope.checkCtrlSelectedHeader = function(ctrlString){
        return checkCtrlSelected(ctrlString, $scope.data.approval);
    };

    var checkCtrlSelected = function(ctrlString, obj){
        return !!impactX.isDefined(obj, 'control.'+ctrlString+'.set.length');
    };

    var checkItemControlsSelected = function (ctrlString, supplier, headerAAT) {
        var itemsSet = true;
        var supplierAAT = impactX.isDefined(supplier, 'aat.selected.id');
        for(var j = 0; j < supplier.items.length; j++) { // check the items
            var item = supplier.items[j];
            if (item.itemType === 0) {
                var itemAAT = impactX.isDefined(item, 'aat.selected.id');
                if (!itemAAT || itemAAT === supplierAAT || (!supplierAAT && itemAAT === headerAAT)) {
                    itemsSet = itemsSet && checkCtrlSelected(ctrlString, item);
                }
            }
        }
        return itemsSet;
    };

    $scope.checkRequireCtrl = function(ctrlString){
        var result = impactX.isDefined($scope, 'data.approval.control.'+ctrlString+'.showMust');
        if(result){
            var allSuppliersSet = true;
            for(var i = 0; i < $scope.data.approval.contracts.length; i++) { // check the supplier headers
                var supplier = $scope.data.approval.contracts[i];
                var supplierAAT = impactX.isDefined(supplier, 'aat.selected.id');
                var supplierIsSet = true;
                if(!supplierAAT || supplierAAT === this.checkAATSelected()){
                    supplierIsSet = checkCtrlSelected(ctrlString, supplier);
                }
                if(!supplierIsSet){ // if the supplier header is not selected...
                    supplierIsSet = checkItemControlsSelected(ctrlString, supplier);
                }
                allSuppliersSet = allSuppliersSet && supplierIsSet;
            }
            result = result && !allSuppliersSet;
        }
        $scope.ctrlRequired[ctrlString] = result;
        if(result){
            presetCtrlIfSingleSelection(impactX.isDefined($scope, 'data.approval.control.'+ctrlString));
        }
        return result;
    };

    $scope.checkRequireCtrlSupplier = function(ctrlString, supplier){
        var showMust = impactX.isDefined(supplier, 'control.'+ctrlString+'.showMust');
        var headerAAT = this.checkAATSelected();
        var supplierAAT = impactX.isDefined(supplier, 'aat.selected.id');

        var headerSelected = false;
        //copied from basket..
        if(!((!headerAAT && supplierAAT) || (headerAAT && supplierAAT && headerAAT !== supplierAAT))){
            headerSelected = this.checkCtrlSelectedHeader(ctrlString);
        }
        var result = showMust && !headerSelected && !checkItemControlsSelected(ctrlString, supplier, headerAAT);
        if(result){
            presetCtrlIfSingleSelection(impactX.isDefined(supplier, 'control.'+ctrlString))
        }
        $scope.contractCtrlsRequired[supplier.supplierHeaderId][ctrlString] = result;
        return result;
    };

    $scope.checkRequireCtrlItem = function(ctrlString, item){
        var supplier = $scope.data.approval.contracts.filter(function(contract){
            return contract.items.filter(function(conItem){
                return item.id === conItem.id;
            }).length > 0;
        })[0];
        
        var showMust = impactX.isDefined(item, 'control.'+ctrlString+'.showMust');
        var itemAAT = impactX.isDefined(item, 'aat.selected.id');
        var supplierAAT = impactX.isDefined(supplier, 'aat.selected.id');
        var headerAAT = this.checkAATSelected();
        var supplierSelected = checkCtrlSelected(ctrlString, supplier);
        var headerSelected = this.checkCtrlSelectedHeader(ctrlString);
        var result = showMust;
        var depth = aatCheckDepth(itemAAT, supplierAAT, headerAAT);
        if(depth > 0){
            result = result && !supplierSelected;
        }
        if(depth > 1){
            result = result && !headerSelected;
        }
        if(result){
            presetCtrlIfSingleSelection(impactX.isDefined(item, 'control.'+ctrlString));
        }
        return result;
    };

    var aatCheckDepth = function(bkiAAT, bksAAT, bkhAAT) {
        //copied from basket..
        var depth = 0;
        if(!bkiAAT) {
            if(!bksAAT || bksAAT === bkhAAT) {
                depth = 2; // AA0 or X00
            } else {
                depth = 1; // BA0 or 0A0
            }
        } else if(!bksAAT) {
            if(bkiAAT === bkhAAT) {
                depth = 2; // A0A
            } // B0A or 00A
        } else if(bkiAAT === bksAAT) {
            if(bksAAT === bkhAAT) {
                depth = 2; // AAA
            } else {
                depth = 1; // BAA or 0AA
            }
        }
        return depth; // XBA
    };

    var presetCtrlIfSingleSelection = function(control){
        if($scope.data.preselectUniqueControls &&
            impactX.isDefined(control, 'set.length') === 0 &&
            impactX.isDefined(control, 'allowed.entries.length') === 1)
        {
            var tmp = [];
            tmp.push(control.allowed.entries[0]);
            tmp[0].factor = 1;
            control.set = tmp;

        }
    };

    $scope.showHeaderControl = function(ctrl, type) {
        return ctrl && ($scope.showControl.value || $scope.ctrlRequired[type] || (ctrl.set&&ctrl.set.length>0));
    };
    
    $scope.showContractControl = function(contractHeader, type) {
        if (contractHeader && contractHeader.control) {
            var ctrl = contractHeader.control[type];
            return ctrl && (($scope.showSupplierControl.value && contractHeader === $scope.selectedContractHeader[0]) ||
                $scope.contractCtrlsRequired[contractHeader.supplierHeaderId][type] ||
                (ctrl.set && ctrl.set.length > 0))
        }
        return false;
    };

    $scope.showCateringDialog = function (event) {
        return $mdDialog.show({
            controller: "CateringDialogViewCtrl",
            controllerAs: "cateringDialogCtrl",
            templateUrl: 'modules/basket/templates/catering.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                atiId: atiId
            }
        });
    }

    $scope.changeAddressHeader = function(ev) {
        return $scope.showAddressChangeDialog(ev, "prh", $scope.data.approval.headerId);
    };

    $scope.changeAddressSupplierHeader = function(ev) {
        return $scope.showAddressChangeDialog(ev, "prs", $scope.selectedContractHeader[0].supplierHeaderId);
    };

    $scope.changeAddressItem = function(ev) {
        return $scope.showAddressChangeDialog(ev, "pri", $scope.selectedItems[0].id);
    };

    var initRequireControl = function() {
        $scope.ctrlRequired = {};
        for (var key in $scope.data.approval.control) {
            $scope.ctrlRequired[key] = $scope.data.approval.control[key].showMust;
        }

        $scope.contractCtrlsRequired = {};
        var len = $scope.data.approval.contracts.length;
        for (var i = 0; i < len; i++) {
            var contract = $scope.data.approval.contracts[i];
            $scope.contractCtrlsRequired[contract.supplierHeaderId] = {};
            for (var key in contract.control) {
                $scope.contractCtrlsRequired[contract.supplierHeaderId][key] = contract.control[key].showMust;
            }
        }
    }

    $scope.canEditSPO = function (supplier) {
        return supplier && supplier.canEditSPO;
    };

    $scope.editSPO = function (event, supplier) {
        SubsequentPurchaseOrderDataService.openEditDialog(event, supplier.supplierHeaderId, "prs");
    }

    $scope.openSubsequentPurchaseOrderDataDialog = function (event, contractHeader) {
        if ($scope.canEditSPO(contractHeader)) {
            $scope.editSPO(event, contractHeader);
        } else {
            SubsequentPurchaseOrderDataService.openViewDialog(event, contractHeader.supplierHeaderId, 0, 0);
        }
    };
}